// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__xT6uL","btn__landscape":"styles_btn__landscape__4J7KO"};